import React, { createContext, useState, useEffect } from "react";

export const LoginContext = createContext();

const getLogin = (isLoginState) => {
  const obj = JSON.parse(localStorage.getItem("login"));
  if (isLoginState) {
    if (
      obj == null ||
      obj.userInfo == undefined ||
      obj.userInfo.id == undefined
    ) {
      return false;
    } else {
      return true;
    }
  } else {
    if (
      obj == null ||
      obj.userInfo == undefined ||
      obj.userInfo.id == undefined
    ) {
      return {};
    } else {
      if (obj.userInfo.id !== undefined) {
        return obj.userInfo;
      }
    }
  }
};

export const LoginProvider = (props) => {
  const [loginState, setLoginState] = useState(getLogin(true));

  const [userInfo, setUserInfo] = useState(getLogin(false));

  useEffect(() => {
    const obj = {
      loginState: loginState,
      userInfo: userInfo,
    };
    localStorage.setItem("login", JSON.stringify(obj));
  }, [loginState, userInfo]);

  const login = (info) => {
    setLoginState(true);
    setUserInfo(info);
  };

  const logout = () => {
    setLoginState(false);
    setUserInfo({});
  };

  return (
    <LoginContext.Provider
      value={{
        loginState: loginState,
        login: login,
        logout: logout,
        userInfo: userInfo,
      }}
    >
      {props.children}
    </LoginContext.Provider>
  );
};
